import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { StaticDynamicTableComponent } from "../../tables/static-dynamic-table/static-dynamic-table.component";

@Component({
  standalone: true,
  selector: 'lib-location-overlay',
  templateUrl: './location-overlay.component.html',
  styleUrls: ['./location-overlay.component.scss'],
  imports: [CommonModule, StaticDynamicTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LocationOverlayComponent {
  @Input() isTableOverlayOpen = false;
  @Input() locationType = '';
  @Input() locationColumns: any =[];
  @Input() locationRows: any =[];
  @Output() overlayClosed = new EventEmitter();

  closeOverlay(){
    this.isTableOverlayOpen = false;
    this.overlayClosed.emit();
  }

}
